import React from "react"
import * as styles from "./grid.module.scss"
import { fromPairs } from 'lodash'
import classNames from 'classnames';

const GridSizes = ['xs','md','lg','xl']

export function GridItem(props) {
    return (
        <div className={styles.gridItem}>
            {props.children}
        </div>
    )
}

export function Grid(props) {
    const columns = fromPairs(GridSizes.filter(s => props[`cols-${s}`]).map(s => [`data-grid-cols-${s}`, props[`cols-${s}`] ]))
    const classes = classNames(styles.grid,{
        [styles.gridIsCentered]: props.centered
    })
    return (
        <div className={classes} {...columns}>
            {props.children}
        </div>
    )
}

